import React, { PureComponent, Fragment } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import $ from "jquery";
import { AJAX_PUBLIC_REQUEST } from '../../../Constants/AppConstants';
import MenuDropdown from '../../../Assets/images/affiliate_imges/affi_dropdown.svg'

class TeamSideMenuLink extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            challengeLoading: false,
            activeChallenges: [],
            activeChallengeTab: 1
        };
    }

    componentDidMount() {
        this.activeChallenges();
    }

    handleDropdownToggle = () => {
        this.setState((prevState) => ({
            is_challenges_open: !prevState.is_challenges_open,
        }));
    };

    activeChallenges = () => {
        this.setState({ loading: true, challengeLoading: true });

        AJAX_PUBLIC_REQUEST("POST", "distributor/getActiveChallenge", {})
            .then(results => {
                const { response } = results;
                if (parseInt(response.code, 10) === 1000) {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);

                    const filteredChallenges = (response.data.active_challenges || []).filter(challenge => {
                        const startDate = new Date(challenge.start_date);
                        const endDate = new Date(challenge.end_date);

                        startDate.setHours(0, 0, 0, 0);
                        endDate.setHours(23, 59, 59, 999);

                        return today >= startDate && today <= endDate;
                    });
                    this.setState({
                        activeChallenges: filteredChallenges,
                        loading: false,
                        challengeLoading: false
                    });
                }
                else {
                    this.setState({ loading: false, challengeLoading: false });
                    console.error("Failed to fetch challenges");
                }
            })
            .catch(error => {
                this.setState({ loading: false, challengeLoading: false });
                console.error("AJAX error:", error);
            });
    };

    handleChallengeSelect = (challengeId) => {
        this.setState({ activeChallengeTab: challengeId });
        localStorage.setItem("activeChallengeTab", challengeId);
    }

    render() {
        return (
            <Fragment>
                <li>
                    <NavLink to="/my-account" activeClassName="active" exact>
                        <i className="fa fa-tachometer" aria-hidden="true"></i> Dashboard
                    </NavLink>
                </li>
                {this.state.activeChallenges && this.state.activeChallenges.length > 0 && (
                    <li className={`dropdown ${this.state.is_challenges_open ? 'open' : ''}`}>
                        <a
                            id="dropdownMenuButton"
                            className="menu_item d-flex align-items-center justify-content-between"
                            href="#"
                            onClick={this.handleDropdownToggle}
                        >
                            <div className="d-flex align-items-center">
                                <i className="fa fa-trophy" aria-hidden="true"></i>
                                <span className="d-block pl_9">Contest Leaderboard</span>
                            </div>
                            <img src={MenuDropdown} alt="dropDown" className="drop_icon" />
                        </a>

                        <div className={`dropdown-menu position-static w-100 afi_dah_show ${this.state.is_challenges_open ? 'show' : ''}`}>
                            <ul>
                                {this.state.activeChallenges.map((challenge) => (
                                    <li key={challenge.id}>
                                        <NavLink
                                            to={`/my-account/challenge/${challenge.id}`}
                                            className={({ isActive }) =>
                                                `dropdown-item d-flex align-items-center font_16 ${this.state.activeChallengeTab == challenge.id || isActive
                                                    ? 'active fw_ar_bold'
                                                    : ''
                                                }`
                                            }
                                            onClick={() => this.handleChallengeSelect(challenge.id)}
                                        >
                                            {challenge.name}
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </li>
                )}
                <li>
                    <NavLink to="/my-account/view-order" activeClassName="active"><i className="fa fa-calendar-check-o" aria-hidden="true"></i> Orders</NavLink>
                </li>
                <li>
                    <NavLink to="/my-account/subscription-order" activeClassName="active"><i className="fa fa-calendar-check-o" aria-hidden="true"></i> Subscription Orders</NavLink>
                </li>
                <li>
                    <NavLink to="/my-account/canceled-subscription" activeClassName="active"><i className="fa fa-calendar-times-o" aria-hidden="true"></i>Canceled Subscription</NavLink>
                </li>
                {/* <li>
                    <NavLink to="/my-account/failed-subscription" activeClassName="active"><i className="fa fa-calendar-minus-o" aria-hidden="true"></i>Failed Subscription</NavLink>
                </li> */}
                {/* <li>
                    <NavLink to="/my-account/affiliate-order" activeClassName="active"><i className="fa fa-calendar-check-o" aria-hidden="true"></i> Affiliate Orders</NavLink>
                </li> */}
                <li>
                    <NavLink to="/my-account/commission-payout" activeClassName="active"><i className="fa fa-calendar-check-o" aria-hidden="true"></i> Commission Earned</NavLink>
                </li>
                <li>
                    <NavLink to="/my-account/product-refer-link" activeClassName="active"><i className="fa fa-link" aria-hidden="true"></i> Refer Link</NavLink>
                </li>
                <li>
                    <NavLink to="/my-account/edit-account" activeClassName="active"><i className="fa fa-user" aria-hidden="true"></i> Account Details</NavLink>
                </li>
            </Fragment>
        );
    }
}

export default withRouter(TeamSideMenuLink);